export default "__VITE_ASSET__Cp$K5NaH__"